import GeneralView from "../components/GeneralView";
import {connect} from "react-redux";
import {isProcessing} from "../actions/processingActions";
import {PROC_CLEAR_CACHE_METADATA} from "../actions";
import {clearMetadataCache} from "../actions/houseActions";

export default connect(
	state => ({
		clearingMetadataCache: isProcessing(state, PROC_CLEAR_CACHE_METADATA)
	}),
	dispatch => ({
		onClearMetadataCache: (onSuccess) => dispatch(clearMetadataCache(onSuccess))
	})
)(GeneralView);


// WEBPACK FOOTER //
// ./src/containers/GeneralController.js